<template>
    <div>
        <div class="md-table md-theme-white">
            <div class="md-content md-table-content">
                <table>
                    <thead>
                        <tr>
                            <th class="md-table-head">
                                <div class="md-table-head-container md-ripple">
                                    <div class="md-table-head-label ">ID</div>
                                </div>
                            </th>
                            <th class="md-table-head">
                                <div class="md-table-head-container md-ripple">
                                    <div class="md-table-head-label ">Название</div>
                                </div>
                            </th>
                            <th class="md-table-head">
                                <div class="md-table-head-container md-ripple">
                                    <div class="md-table-head-label ">ip</div>
                                </div>
                            </th>
                            <th class="md-table-head">
                                <div class="md-table-head-container md-ripple">
                                    <div class="md-table-head-label">Порт</div>
                                </div>
                            </th>
                            <th class="md-table-head">
                                <div class="md-table-head-container md-ripple">
                                    <div class="md-table-head-label">Статус</div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="table-body md-scrollbar">
                        <tr class="md-table-row" v-for="printer in $props.value" v-bind:key="printer.id">
                            <td class="md-table-cell">
                                <div class="md-table-cell-container"> {{printer.id}} </div>
                            </td>
                            <td class="md-table-cell">
                                <div class="md-table-cell-container"> {{printer.name}} </div>
                            </td>
                            <td class="md-table-cell">
                                <div class="md-table-cell-container"> {{printer.ip}} </div>
                            </td>
                            <td class="md-table-cell">
                                <div class="md-table-cell-container"> {{printer.port}} </div>
                            </td>
                            <td class="md-table-cell">
                                <div class="md-table-cell-container"> {{(printer.status ? printer.status.name : 'Не установлен')}} </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
}
</script>


// WEBPACK FOOTER //
// StockPrinters.vue?fcd37b82